import { render, staticRenderFns } from "./VxBreadcrumb.vue?vue&type=template&id=00ac28f1&scoped=true&"
import script from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./VxBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./VxBreadcrumb.vue?vue&type=style&index=0&id=00ac28f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac28f1",
  null
  
)

export default component.exports